import React from 'react'
import { Typography, Row, Col } from 'antd'
import Button from 'components/shared/button'
import PropTypes from 'prop-types'

const { Title } = Typography

export default function Heading({ term }) {
  const {
    attributes: {
      seo_meta: { title },
    },
  } = term
  return (
    <>
      <Row className="page-wrapper">
        <Col span={22}>
          <Title
            level={3}
            style={{
              fontWeight: 'normal',
              fontSize: '24px',
              lineHeight: '29px',
              letterSpacing: '-0.015em',
            }}
          >
            Common Financial Terms & Concepts
            <Button
              size="large"
              type="primary"
              style={{ float: 'right' }}
              source="ft-share-button"
            >
              Share
            </Button>
          </Title>
        </Col>
      </Row>
      <Row className="page-wrapper">
        <Col span={20}>
          <Title level={1}>{title}</Title>
        </Col>
      </Row>
    </>
  )
}

Heading.propTypes = {
  term: PropTypes.shape({
    short_description: PropTypes.string,
    seo_meta: PropTypes.shape({
      title: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
}
